const SOUND_KEY = 'chat:sound'
const ALERTS_KEY = 'chat:alerts'
const BEEP_STEPS = [[880, 0], [1175, 0.11]]
const BEEP_STEP_SECONDS = 0.14
const BEEP_GAIN = 0.12

let audioContext = null

function readStorage(key) {
  try {
    return window.localStorage.getItem(key)
  } catch (e) {
    return null
  }
}

function writeStorage(key, value) {
  try {
    window.localStorage.setItem(key, value)
  } catch (e) {
    // Sem storage (janela privada): a preferência vale só até recarregar.
  }
}

export function soundEnabled() {
  return readStorage(SOUND_KEY) !== 'off'
}

export function setSoundEnabled(on) {
  writeStorage(SOUND_KEY, on ? 'on' : 'off')
}

/** Avisos visuais (toast e notificação do sistema) de mensagem recebida fora da conversa aberta. */
export function alertsEnabled() {
  return readStorage(ALERTS_KEY) !== 'off'
}

export function setAlertsEnabled(on) {
  writeStorage(ALERTS_KEY, on ? 'on' : 'off')
}

/** Dois tons curtos gerados no navegador: não depende de arquivo de áudio. */
export function playBeep() {
  if (!soundEnabled()) return
  const Context = window.AudioContext || window.webkitAudioContext
  if (!Context) return

  try {
    audioContext = audioContext || new Context()
    // Autoplay: sem gesto prévio do usuário o contexto fica suspenso e o som simplesmente não toca.
    if (audioContext.state === 'suspended') audioContext.resume()

    const now = audioContext.currentTime
    BEEP_STEPS.forEach(([frequency, offset]) => {
      const osc = audioContext.createOscillator()
      const gain = audioContext.createGain()
      osc.type = 'sine'
      osc.frequency.value = frequency
      gain.gain.setValueAtTime(BEEP_GAIN, now + offset)
      gain.gain.exponentialRampToValueAtTime(0.0001, now + offset + BEEP_STEP_SECONDS)
      osc.connect(gain)
      gain.connect(audioContext.destination)
      osc.start(now + offset)
      osc.stop(now + offset + BEEP_STEP_SECONDS)
    })
  } catch (e) {
    // Som é cortesia: nunca deve quebrar o recebimento da mensagem.
  }
}

export const canNotify = () => typeof window !== 'undefined' && 'Notification' in window

/** granted | denied | default | unsupported */
export const notificationPermission = () => (canNotify() ? Notification.permission : 'unsupported')

/** Pede a permissão uma única vez; se o usuário já negou, respeita e não insiste. */
export function requestNotificationPermission() {
  if (!canNotify() || Notification.permission !== 'default') return
  try {
    const result = Notification.requestPermission()
    if (result && result.catch) result.catch(() => {})
  } catch (e) {
    // Navegadores antigos usam callback e podem lançar: segue sem notificação nativa.
  }
}

/** A janela está fora de vista: minimizada, em outra aba ou atrás de outro programa. */
export const windowAway = () => document.visibilityState !== 'visible' || !document.hasFocus()

/**
 * Notificação do sistema (no Windows, o balão do canto e a central de notificações), que aparece mesmo com
 * o navegador minimizado. `tag` agrupa as mensagens da mesma conversa em uma só. Devolve se foi exibida.
 */
export function showBrowserNotification({
  title, body, tag, icon, onClick,
}) {
  if (!canNotify() || Notification.permission !== 'granted') return false
  try {
    const notification = new Notification(title, {
      body, tag, renotify: true, icon: icon || '/favicon.ico',
    })
    notification.onclick = () => {
      window.focus()
      notification.close()
      if (onClick) onClick()
    }

    return true
  } catch (e) {
    // Alguns navegadores móveis só aceitam via service worker.
    return false
  }
}
